import { Country } from '@viewbid/ts-angular-client';

export interface Location {
    value: string;
    viewValue: string;
    country: string;
}

export const Countries: Location[] = [
    { value: Country.Ca, viewValue: 'Canada', country: Country.Ca },
    {
        value: Country.Us,
        viewValue: 'United States of America',
        country: Country.Us,
    },
];

export const Provinces: Location[] = [
    { value: 'Alberta', viewValue: 'Alberta', country: Country.Ca },
    {
        value: 'British Columbia',
        viewValue: 'British Columbia',
        country: Country.Ca,
    },
    { value: 'Manitoba', viewValue: 'Manitoba', country: Country.Ca },
    {
        value: 'New Brunswick',
        viewValue: 'New Brunswick',
        country: Country.Ca,
    },
    {
        value: 'Newfoundland and Labrador',
        viewValue: 'Newfoundland and Labrador',
        country: Country.Ca,
    },
    { value: 'Nova Scotia', viewValue: 'Nova Scotia', country: Country.Ca },
    { value: 'Ontario', viewValue: 'Ontario', country: Country.Ca },
    {
        value: 'Prince Edward Island',
        viewValue: 'Prince Edward Island',
        country: Country.Ca,
    },
    { value: 'Quebec', viewValue: 'Quebec', country: Country.Ca },
    { value: 'Saskatchewan', viewValue: 'Saskatchewan', country: Country.Ca },
    {
        value: 'Northwest Territories',
        viewValue: 'Northwest Territories',
        country: Country.Ca,
    },
    { value: 'Nunavut', viewValue: 'Nunavut', country: Country.Ca },
    { value: 'Yukon', viewValue: 'Yukon', country: Country.Ca },
    { value: 'Alabama', viewValue: 'Alabama', country: Country.Us },
    { value: 'Alaska', viewValue: 'Alaska', country: Country.Us },
    { value: 'Arizona', viewValue: 'Arizona', country: Country.Us },
    { value: 'Arkansas', viewValue: 'Arkansas', country: Country.Us },
    {
        value: 'California',
        viewValue: 'California',
        country: Country.Us,
    },
    { value: 'Colorado', viewValue: 'Colorado', country: Country.Us },
    { value: 'Connecticut', viewValue: 'Connecticut', country: Country.Us },
    { value: 'Delaware', viewValue: 'Delaware', country: Country.Us },
    { value: 'Florida', viewValue: 'Florida', country: Country.Us },
    { value: 'Georgia', viewValue: 'Georgia', country: Country.Us },
    { value: 'Hawaii', viewValue: 'Hawaii', country: Country.Us },
    { value: 'Idaho', viewValue: 'Idaho', country: Country.Us },
    { value: 'Illinois', viewValue: 'Illinois', country: Country.Us },
    { value: 'Pennsylvania', viewValue: 'Pennsylvania', country: Country.Us },
    { value: 'Rhode Island', viewValue: 'Rhode Island', country: Country.Us },
    {
        value: 'South Carolina',
        viewValue: 'South Carolina',
        country: Country.Us,
    },
    { value: 'South Dakota', viewValue: 'South Dakota', country: Country.Us },
    {
        value: 'Tennessee',
        viewValue: 'Tennessee',
        country: Country.Us,
    },
    { value: 'Texas', viewValue: 'Texas', country: Country.Us },
    { value: 'Utah', viewValue: 'Utah', country: Country.Us },
    { value: 'Vermont', viewValue: 'Vermont', country: Country.Us },
    { value: 'Virginia', viewValue: 'Virginia', country: Country.Us },
    { value: 'Washington', viewValue: 'Washington', country: Country.Us },
    { value: 'West Virginia', viewValue: 'West Virginia', country: Country.Us },
    { value: 'Idaho', viewValue: 'Idaho', country: Country.Us },
    { value: 'Illinois', viewValue: 'Illinois', country: Country.Us },
    { value: 'Indiana', viewValue: 'Indiana', country: Country.Us },
    { value: 'Iowa', viewValue: 'Iowa', country: Country.Us },
    { value: 'Kansas', viewValue: 'Kansas', country: Country.Us },
    { value: 'Arkansas', viewValue: 'Arkansas', country: Country.Us },
    { value: 'Kentucky', viewValue: 'Kentucky', country: Country.Us },
    { value: 'Louisiana', viewValue: 'Louisiana', country: Country.Us },
    { value: 'Maine', viewValue: 'Maine', country: Country.Us },
    { value: 'Maryland', viewValue: 'Maryland', country: Country.Us },
    { value: 'Massachusetts', viewValue: 'Massachusetts', country: Country.Us },
    { value: 'Michigan', viewValue: 'Michigan', country: Country.Us },
    { value: 'Minnesota', viewValue: 'Minnesota', country: Country.Us },
    { value: 'Mississippi', viewValue: 'Mississippi', country: Country.Us },
    { value: 'Missouri', viewValue: 'Missouri', country: Country.Us },
    { value: 'Montana', viewValue: 'Montana', country: Country.Us },
    { value: 'Nebraska', viewValue: 'Nebraska', country: Country.Us },
    { value: 'Nevada', viewValue: 'Nevada', country: Country.Us },
    { value: 'New Hampshire', viewValue: 'New Hampshire', country: Country.Us },
    { value: 'New Jersey', viewValue: 'New Jersey', country: Country.Us },
    { value: 'New Mexico', viewValue: 'New Mexico', country: Country.Us },
    { value: 'New York', viewValue: 'New York', country: Country.Us },
    {
        value: 'North Carolina',
        viewValue: 'North Carolina',
        country: Country.Us,
    },
    { value: 'North Dakota', viewValue: 'North Dakota', country: Country.Us },
    { value: 'Ohio', viewValue: 'Ohio', country: Country.Us },
    { value: 'Wisconsin', viewValue: 'Wisconsin', country: Country.Us },
    { value: 'Oklahoma', viewValue: 'Oklahoma', country: Country.Us },
    { value: 'Oregon', viewValue: 'Oregon', country: Country.Us },
    { value: 'Wyoming', viewValue: 'Wyoming', country: Country.Us },
];
